<template>
  <div>
    <el-row>
      <el-col :span="14" class="cs-auen-step2-left">
        <div>
          <span class="cs-title">价格合算结果</span>
        </div>
        <courseList ref="courseList" :isReadonly="isReadonly" :hasPrice="true" :dataIn="courseListData" @edit="onEdit" />

      </el-col>
      <el-col :span="10" class="cs-auen-step2-right">
        <el-row>
          <el-col>
            优惠折扣码
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-input v-if="!isReadonly" placeholder="请输入优惠折扣码" v-model.trim="model.discountCode" class="input-width">
            </el-input>
            <span v-else>{{model.discountCode}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-button v-if="!isReadonly" type="primary" size="small" :disabled="isLoading" :loading="isLoading"
              @click="onConfirm">确认</el-button>
            <el-button v-if="!isReadonly" type="primary" size="small" :disabled="isLoading" :loading="isLoading"
              @click="onRemove">清除</el-button>
          </el-col>
        </el-row>
        <el-row class="cs-useBalanceEditor-container">
          <el-col>
            <useBalanceEditor ref="useBalanceEditor" :isAutonomousEnrolment="true" :isReadOnly="isReadonly" :displayEnrollmentCount="true"
              :dataIn="usebalanceEditorData" @valueChange="onUseBalanceEditorValueChange"></useBalanceEditor>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.cs-auen-step2-left,
.cs-auen-step2-right {
  margin-top: 1rem;
}
.cs-auen-step2-left {
  border-right: 1px solid #ced3d9;
  padding-right: 20px;
}
.cs-auen-step2-right {
  padding-left: 20px;

  button {
    margin-top: 10px;
  }
  .el-input {
    margin-top: 5px;
  }

  .cs-useBalanceEditor-container{
    margin-top: 10px;
  }
}
</style>

<script>
import { CourseListEx } from "./courseListEx";
import bonusPointMechanismVue from "../../../page/admin/bonusPointMechanism.vue";
import courseList from "./courseList";
import useBalanceEditor from "../../addCollectFees/useBalanceEditor";

export default {
  props: {
    isReadonly: Boolean,
    dataIn: {
      studentId: Number,
      workflowId: Number,
      studentMemberInfo: Object,
      courseList: Object,
      model: {
        discountCode: String,
      },
      priceSettings: Object,
      studentAdvanceEnrollmentList: Array,
      advanceEnrollmentTotalPrice: Number,
      modelData: {
        enrollmentCount: Number,
        balance: Number,
        bonusPoint: Number,
        cashDecreased: Number,
        studentAdvanceEnrollmentAdditional: String,
        comment: String
      }
    },
  },
  data() {
    return {
      isLoading: false,
      courseListData: {
        studentMemberInfo: {},
        courseList: new CourseListEx([]),
      },
      model: {
        discountCode: "",
      },
      usebalanceEditorData: {
        workflowId: 0,
        memberModel: {},
        enrollmentCountUsed: 0,
        accountAmount: 0,
        accountAmountWithTax: 0,
        priceSettings: {},
        modelData: {},
        modelUsedData: {},
        courseType: 1,
        studentAdvanceEnrollmentList: [],
      },
    };
  },
  components: {
    courseList,
    useBalanceEditor,
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.dataIn) {
        this.model = this.dataIn.model;
        this.courseListData = {
          studentMemberInfo: this.dataIn.studentMemberInfo,
          courseList: this.dataIn.courseList,
        };
        this.$nextTick(() => {
          let accountAmount = this.dataIn.courseList.calcAccountAmount();

          let modelUsedData = {
            enrollmentCount: 0,
            balance: 0,
            balanceTax: 0,
            bonusPoint: 0,
            cashDecreased: 0,
            couponDiscountDollar: 0,
            studentAdvanceEnrollmentAdditional: "",
            comment: "",
          };
          this.usebalanceEditorData = {
            workflowId: this.dataIn.workflowId,
            memberModel: this.dataIn.studentMemberInfo,
            enrollmentCountUsed: 0,
            accountAmount: accountAmount,
            accountAmountWithTax: accountAmount,
            priceSettings: this.dataIn.priceSettings,
            modelData: this.dataIn.modelData,
            modelUsedData: modelUsedData,
            courseType: 1,
            studentAdvanceEnrollmentList:
              this.dataIn.studentAdvanceEnrollmentList,
            advanceEnrollmentTotalPrice:
              this.dataIn.advanceEnrollmentTotalPrice,
          };
        });
      }
    },
    onConfirm() {
      if (!this.model.discountCode) {
        this.$message.warning("请输入优惠折扣码");
        return;
      }
      this.triggerCalculate();
    },
    onRemove() {
      if (this.model.discountCode) {
        this.$confirm("您确认要清除该优惠吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.model.discountCode = "";
            this.triggerCalculate();
          })
          .catch(() => {});
      }
    },
    triggerCalculate() {
      this.isLoading = true;
      this.$emit("calculate");
      this.$emit("edit");
    },
    finishLoading(isSuccess) {
      this.isLoading = false;
    },
    onEdit() {
      this.$emit("edit");
    },
    onUseBalanceEditorValueChange(result, isReduce, isMoveNext) {
      this.$emit("useBalanceEditorValueChange", result, isMoveNext);
    },
    isBalanceEditorChange(){
      return this.$refs.useBalanceEditor.isChanged;
    },
    saveBalanceEditor(){
      this.$refs.useBalanceEditor.save(true);
    }
  },
  watch: {
    dataIn: function () {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/autonomousEnrolment/workflow/step2.vue